import {Component, OnInit, Input, Output, EventEmitter,ViewChild} from '@angular/core';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {FormGroup, FormControl, FormBuilder, Validators, AbstractControl} from '@angular/forms';
import {FundperformanceService} from '../services/fundperformance.service';
import {ChartConfigService} from '../services/chartconfig.service';
import * as moment from 'moment';
import * as jsPDF from 'jspdf'
import { DatePickerComponent } from 'ng2-date-picker';

@Component({
  selector: 'app-fundperformance',
  templateUrl: './fundperformance.component.html',
  styleUrls: ['./fundperformance.component.css']
})
export class FundperformanceComponent implements OnInit {
  @Input() viewFormat:string;
  @ViewChild('monthPicker') datePicker: DatePickerComponent;
  @ViewChild('monthPicker2') datePicker2: DatePickerComponent;
//socket data
  public langSubscription: any = {};
  public progressIndicator = 'nodata';
  public initialRequest;
  public charts;
  public fundMap;
  public chart:any;
  public fundChart;
  public lang;
  public fundData;
  date = new Date();
  options;
  canvas;
  dataURL;
  currentLang;
  public basedOn;
  public invalidDateRange:boolean = false;
  public moreThan24Months:boolean = false;
  public buttonDisabled:boolean = false;
  public showFundCustom:boolean = false;
  public benchmarkLabel;
  public intervalId;
  public fromDateVal = moment().add(-1, 'months').toDate();
  fromDate = moment(this.fromDateVal,'jYYYY,jMM,jDD');

  public toDateVal = moment().toDate();
  toDate = moment(this.toDateVal,'jYYYY,jMM,jDD');
  public searchHistory;
  public chosenTab = '1MONTH';
  public choseperiod = false;
  public chose1year = false;
  public chose1month = false;
  public chose3month = false;
  public showCustomRange = false;
  public isDayDisabled;
  public clearSearch:boolean = true;
  max = moment();
  datePickerConfig = {
    drops: 'down',
    format: 'MMM-YYYY',
    closeOnSelect:true,
    disabled:true,
    max:this.max,
    yearFormat:"YYYY",
    disableKeypress:true,
    opens: "right"
  };
  public constructor(private trackerService:FundperformanceService,
                     public chartService:ChartConfigService,
                     private translate:TranslateService) {

                      this.lang = translate.currentLang;
                      this.langSubscription = this.langSubscription = this.translate.onLangChange.subscribe((event:LangChangeEvent) => {
                        this.lang = event.lang;
                        this.initialRequest = 1;
                        if (this.chosenTab === '1YEAR') {
                          this.request1YearChartData(this.initialRequest);
                        } else if (this.chosenTab === '1MONTH') {
                          this.request1MonthChartData(this.initialRequest);
                        } else if (this.chosenTab === '3MONTH') {
                          this.request3MonthChartData(this.initialRequest);
                        } else {
                          if (this.charts.length > 0) {
                            this.requestPerformance();
                          }
                        }
                      });
                      this.trackerService.receive().subscribe(data => {
                        if (this.intervalId) {
                          clearInterval(this.intervalId);
                        }
                        if(data.length == 0){
                          this.progressIndicator = "nodata";
                        } else {
                          this.progressIndicator = "loaded";
                        }
                        this.onResponseReceived(data);

                      });
                      this.options = {
                        format: "MMM-YYYY"
                      }
  }

  public customFundForm = new FormGroup({
    'fundStartDate' : new FormControl('',Validators.required),
    'fundEndDate' : new FormControl('',Validators.required)
  });
  public fundStartDate: AbstractControl = this.customFundForm.get('fundStartDate');
  public fundEndDate: AbstractControl = this.customFundForm.get('fundEndDate');
  public barChartOptions;
  public barChartType:string = 'bar';
  public barChartLegend:boolean = true;
  public chartColors = this.chartService.barChartColors;

  ngOnInit() {
    this.benchmarkLabel = 'Benchmark Legend:';
    this.checkBasedOn();
    if (this.viewFormat) {
      this.options = this.viewFormat || this.options;
    }
    this.initialRequest = 0;
    if (this.chosenTab === '1YEAR') {
      this.request1YearChartData(this.initialRequest);
    } else if (this.chosenTab === '1MONTH') {
      this.request1MonthChartData(this.initialRequest);
    } else if (this.chosenTab === '3MONTH') {
      this.request3MonthChartData(this.initialRequest);
    } else {
      if (this.charts.length > 0) {
        this.requestPerformance();
      }
    }
  }

  ngOnDestroy() {
    this.langSubscription.unsubscribe();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  dateOpen() {
    this.datePicker.api.open();
  }
  dateOpen2() {
    this.datePicker2.api.open();
  }
  public initChartData() {
    this.charts = [];
  }
  public loadChartData(type) {
    this.invalidDateRange = false;
    this.moreThan24Months = false;
    this.initialRequest = 1;
    if (type === '1YEAR') {
      this.showCustomRange = false;
      this.request1YearChartData(this.initialRequest);
    }
    else if (type === '1MONTH') {
      this.showCustomRange = false;
      this.request1MonthChartData(this.initialRequest);
    }
    else if (type === '3MONTH') {
      this.showCustomRange = false;
      this.request3MonthChartData(this.initialRequest);
    }
    else {
      this.benchmarkLabel = '';
      this.chose1year = false;
      this.choseperiod = true;
      this.chose1month = false;
      this.chose3month = false;
      this.showCustomRange = true;
      this.initChartData();
      this.requestPerformance();
    }
  }

  public requestPerformance() {
    if(this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.clearSearch = true;
    this.benchmarkLabel = 'Benchmark Legend';
    this.invalidDateRange = false;
    this.moreThan24Months = false;
    this.showCustomRange = true;
    this.chose1year = false;
    this.choseperiod = true;
    this.chose1month = false;
    this.chose3month = false;

    this.chosenTab = "PERIOD";
    let startDate = moment(this.fromDate).format("YYYY-MM-") + '01';
    let endDate = moment(this.toDate).format("YYYY-MM-") + '28';

    var diff = moment(this.fromDate).diff(moment(this.toDate), 'months');
    if(startDate > endDate){
      this.invalidDateRange = true;
    } else if(Math.abs(diff) >= 24){
      this.moreThan24Months = true;
    } else{
      this.progressIndicator = 'loading';
      this.initResponseTimeoutHandler();
      this.trackerService.sendActivity(startDate, endDate, this.lang);

    }
  }

  public request1YearChartData(flag) {
    if(this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.progressIndicator = 'loading';
    this.initResponseTimeoutHandler();
    this.chose1year = true;
    this.choseperiod = false;
    this.chose1month = false;
    this.chose3month = false;

    this.chosenTab = "1YEAR";
    var end = moment();
    var start = moment(end).add(-1, 'years');

    var startDate = start.format('YYYY-MM-DD');
    var endDate = end.format('YYYY-MM-DD');
    if (flag == 0) {
      this.trackerService.connect(startDate, endDate, this.lang);
      this.trackerService.subscribe();
    }
    if (flag == 1) {
      this.trackerService.sendActivity(startDate, endDate, this.lang);
    }
  }

  public request3MonthChartData(flag) {
    if(this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.progressIndicator = 'loading';
    this.initResponseTimeoutHandler();
    this.chose1year = false;
    this.choseperiod = false;
    this.chose1month = false;
    this.chose3month = true;

    this.chosenTab = "3MONTH";
    var end = moment();
    var start = moment(end).add(-3, 'months');

    var startDate = start.format('YYYY-MM-DD');
    var endDate = end.format('YYYY-MM-DD');
    if (flag == 0) {
      this.trackerService.connect(startDate, endDate, this.lang);
      this.trackerService.subscribe();
    }
    if (flag == 1) {
      this.trackerService.sendActivity(startDate, endDate, this.lang);
    }
  }

  public request1MonthChartData(flag) {
    if(this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.progressIndicator = 'loading';
    this.initResponseTimeoutHandler();
    this.chose1year = false;
    this.choseperiod = false;
    this.chose1month = true;
    this.chose3month = false;

    this.chosenTab = "1MONTH";
    var end = moment();
    var start = moment(end).add(-1, 'months');

    var startDate = start.format('YYYY-MM-DD');
    var endDate = end.format('YYYY-MM-DD');
    if (flag == 0) {
      this.trackerService.connect(startDate, endDate, this.lang);
      this.trackerService.subscribe();
    }
    if (flag == 1) {
      this.trackerService.sendActivity(startDate, endDate, this.lang);
    }
  }

  public onResponseReceived(data) {
    this.fundData = data;
    this.initChartData();
    this.charts = [];
    this.fundMap = {};
    for (var i = 0; i <= this.fundData.length; i++) {
      if (this.fundData[i] !== null && this.fundData[i] !== undefined) {
        this.chart = {
          title: '',
          fund: '',
          series: ['Performance', 'Benchmark '],
          labels: [],
          datasets: [{data: [], label: ''}, {data: [], label: ''}],
          benchmarkSource: []
        };
        this.fundChart = this.fundMap[this.fundData[i].fundCode];
        if (this.fundChart !== null && this.fundChart !== undefined) {
          this.chart = this.fundChart;
        }
        this.chart.title = this.fundData[i].title;
        this.chart.fundCode = this.fundData[i].fundCode;
        //chart.series.push(fund.fundcode);
        var label = moment(this.fundData[i].entryDate).format('MMM YYYY');
        this.chart.labels.push(label);
        this.chart.datasets[0].data.push(this.fundData[i].performance);
        this.chart.datasets[0].label = 'Performance';
        this.chart.datasets[1].data.push(this.fundData[i].benchmark);
        this.chart.datasets[1].label = 'Benchmark';

        this.chart.benchmarkSource.push(this.fundData[i].benchmarkSource);
        this.fundMap[data[i].fundCode] = this.chart;
      }
    }
    for (var key in this.fundMap) {
      if (this.fundMap.hasOwnProperty(key)) {
        var chart = this.fundMap[key];
        //var lang = $translate.use();
        var series = 'Benchmark based on ';
        if (this.lang !== 'en') {
          series = 'Benchmark berdasarkan ';
        }
        series = 'Benchmark Benchmark Benchmark Benchmark Benchmark Benchmark Benchmark';//series + chart.benchmarkSource[0];
        chart.series[1] = series;
        this.charts.push(chart);
      }
    }
    if (this.charts.length > 0) {
      this.progressIndicator = "loaded";
      this.barChartOptions = this.chartService.chartOptions(-5, 5);

    } else {
      this.progressIndicator = "nodata";
    }
    if (this.fundData.length == 0) {
      this.progressIndicator = "nodata";
    }
  }

  initResponseTimeoutHandler() {
    this.intervalId = setInterval(() => {
      if (this.progressIndicator === "loading") {
        console.log('2 minutes waiting for fund performance response is over.. Show timeout message!');
        this.progressIndicator = "timeout";
      }
    }, 120000);
  }

  checkBasedOn() {
    this.basedOn = 'Benchmark based on ';

  }

  exportToPdf() {
    var pdf = null;
    pdf = new jsPDF('p', 'mm');
    for (var i = 0; i <= this.charts.length; i++) {
      if (this.charts[i] !== null && this.charts[i] !== undefined) {
        var title = document.getElementById('chart-label-' + i);
        this.canvas = document.getElementById("chart-data-" + i);
        this.dataURL = this.canvas.toDataURL();
        var x = 20;
        var titleY = 20;
        var chartY = 20;
        var even = ((i + 1) % 2) === 0;
        if (even) {
          titleY = 165;
          chartY = 180;
        } else {
          chartY = chartY + 15;
        }
        pdf.text(x, titleY, this.charts[i].title);
        pdf.addImage(this.canvas.toDataURL(), 'JPEG', x, chartY);
        if (i < (this.charts.length - 1) && even) {
          pdf.addPage();
        }
      }
    }
    var filename = 'fund-performance';
    if (this.chosenTab !== null || this.chosenTab !== undefined) {
      filename = filename + '-' + this.chosenTab.toLowerCase();
    }
    pdf.save(filename + '.pdf');
  }

}
